import { MsgModel } from './../../common-components/msg/model/msg.model';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserProfileService } from '../service/user-profile.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { login } from '../../auth/state/auth.actions';

@Component({
    selector: 'app-change-password-user-profile',
    templateUrl: './change-password-user-profile.component.html',
    styleUrls: ['./change-password-user-profile.component.scss']
})
export class ChangePasswordUserProfileComponent implements OnInit {
    form!: UntypedFormGroup;

    oldPassword: string = '';
    passwordToConfirm: string = '';

    hide: boolean = true;

    isLoading: boolean = false;
    msg: MsgModel = {};

    constructor(private fb: UntypedFormBuilder, private userProfileService: UserProfileService, private store: Store<AppState>) {
        this.form = fb.group({
            oldPassword: ['', [Validators.required]],
            password: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {}

    changePassword() {
        if (this.form.valid) {
            this.isLoading = true;
            this.userProfileService.changePassword(this.form.get('oldPassword')?.value, this.form.get('password')?.value).subscribe((res) => {
                if (res.msg) {
                    this.msg = res.msg;
                    const userToken = res;

                    if (this.msg.SUCCESS) {
                        this.store.dispatch(login({ userToken }));
                    } else {
                        this.isLoading = false;
                    }
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please check your inputs.' };
        }
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
